export const environment = {
  envName: 'UAT',
  production: false,
  apiUrl: 'https://uat.ckk-new.riseplus.tech/api',
  version: 'v16.0',
};
